import { Subject } from 'rxjs';
import { IGlobalFeatures, ISingleFeature } from '../../types';
import { gnov, snov } from '../../utils';

interface IParams {
  singleFeatures: ISingleFeature[];
  context: {
    features: IGlobalFeatures;
    featuresSubject: Subject<IGlobalFeatures>;
  };
}

/**
 * This function will check if the feature is already set and if it changed. In case any feature has
 * changed it will emit the new features to the featuresSubject.
 *
 * @param {ISingleFeature[]} singleFeatures features that will be set
 */
function setFeatures({ singleFeatures, context }: IParams): void {
  const { features, featuresSubject } = context;
  let emitEvent = false;

  for (const sf of singleFeatures) {
    const { path, value } = sf;

    const currentValue = gnov(features, path);

    if (currentValue !== value && !emitEvent) {
      // When the first feature changes we're going to change the emitEvent to true
      emitEvent = true;
    }

    snov(features, path, value);
  }

  if (emitEvent) {
    featuresSubject.next(features);
  }
}

export default setFeatures;
